/**
 * Implements a pricing plan computation logic
 * and a display
 */
import Text from '../../../atoms/Text';
import Button from '../../../molecules/Button';

const PLANS = [
  {
    amount: 0,
    name: 'Free',
    icon: 'free',
  },
  {
    amount: 130,
    name: 'Pro',
    icon: 'pro',
  },
  {
    amount: 250,
    name: 'Pro+',
    icon: 'proplus',
  },
  {
    amount: 400,
    name: 'Zen',
    icon: 'zen',
  },
];

const getCurrentPlan = (balance: number) => {
  const plans = PLANS.filter((plan: any) => plan.amount <= balance);
  if (plans.length > 0) {
    return plans[plans.length - 1];
  }
  return PLANS[0];
};

export const usePricingPlan = ({ balance }: any) => {
  const currentPlan = getCurrentPlan(balance);
  const nextPlanIndex = PLANS.indexOf(currentPlan) + 1;
  const nextPlan = PLANS[nextPlanIndex];

  return {
    currentPlan,
    nextPlan,
  };
};

const PricingPlans = ({ balance, onBuy }: any) => {
  const { currentPlan, nextPlan } = usePricingPlan({ balance });

  return (
    <>
      <div className='ktn_balance'>
        <div className={`plan plan--${currentPlan.icon}`}>
          <span className='plan__caption'>{currentPlan.name}</span>
        </div>
        <Text size={16} className='text--grey-200 text--weight-500'>
          {balance % 1 === 0 ? balance : balance.toFixed(6)} KTN
        </Text>
        {/* <div className='ktn_balance__btn'>
          <Button
            size='xs'
            action={onBuy}
            text={`Get ${nextPlan.name}`}
            variant='secondary'
          />
        </div> */}
      </div>
    </>
  );
};

export default PricingPlans;
